import PrivateCoachingList from "@/views/App/Unemployed/Coaching/PrivateCoaching/List.vue";
import PrivateCoachingInquiryListForCoach from "@/views/App/Unemployed/Coaching/PrivateCoaching/InquiryOverview/InquiryForCoachList.vue";
import GroupCoachingList from "@/views/App/Unemployed/Coaching/GroupCoaching/List.vue";
import SocioTherapyCoachingList from "@/views/App/Unemployed/Coaching/SocioTherapyCoaching/List.vue";
import AssistedLivingCoachingList from "@/views/App/Unemployed/Coaching/AssistedLivingCoaching/List.vue";
import CaseManagementCoachingList from "@/views/App/Unemployed/Coaching/CaseManagementCoaching/List.vue";
import PrivateLearningCoachingList from "@/views/App/Unemployed/Coaching/PrivateLearningCoaching/List.vue";

// Digital documents
import PrivateCoachingDigitalDocuments from "@/views/App/Unemployed/DigitalDocuments/PrivateCoaching/List.vue";

const routesUnemployedOverview = [
    {
        path: ':id/private-coaching',
        name: 'unemployedPrivateCoachingList',
        component: PrivateCoachingList
    },
    {
        path: ':id/group-coaching',
        name: 'unemployedGroupCoachingList',
        component: GroupCoachingList
    },
    {
        path: ':id/socio-therapy-coaching',
        name: 'unemployedSocioTherapyCoachingList',
        component: SocioTherapyCoachingList
    },
    {
        path: ':id/assisted-living-coaching',
        name: 'unemployedAssistedLivingCoachingList',
        component: AssistedLivingCoachingList
    },
    {
        path: ':id/case-management-coaching',
        name: 'unemployedCaseManagementCoachingList',
        component: CaseManagementCoachingList
    },
    {
        path: ':id/private-learning-coaching',
        name: 'unemployedPrivateLearningCoachingList',
        component: PrivateLearningCoachingList
    },

    // Inquiry
    {
        path: 'private-coaching/inquiry-list-for-coach',
        name: 'unemployedPrivateCoachingInquiryOverviewListForCoach',
        component: PrivateCoachingInquiryListForCoach
    },


    // Digital documents
    {
        path: ':id/private-coaching-documents',
        name: 'unemployedPrivateCoachingDocuments',
        component: PrivateCoachingDigitalDocuments
    },
];

export default routesUnemployedOverview;